export const TEST_ID = 'issue.views.common.child-issues-panel.child-issues-limit-panel';
export const LEARN_MORE_LINK_TEST_ID = `${TEST_ID}.learn-more-link`;
export const VIEW_IN_SEARCH_BUTTON_TEST_ID = `${TEST_ID}.view-in-search-button`;
export const BULK_EDIT_BUTTON_TEST_ID = `${TEST_ID}.bulk-edit-button`;
